import { render, staticRenderFns } from "./dialogApprovalRequestHistory.vue?vue&type=template&id=00b6a9a2&scoped=true&lang=pug&"
import script from "./dialogApprovalRequestHistory.vue?vue&type=script&lang=js&"
export * from "./dialogApprovalRequestHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6a9a2",
  null
  
)

export default component.exports